import UserDataService from 'common/services/userData.service.js';

class VacationUserDataService extends UserDataService {
  constructor() {
    super();
  }

  getVacationTypes() {
    return this._employee.vacationTypes;
  }

  getAbsenceTypes() {
    return this._employee.absenceTypes;
  }

  getMatPatPeriods() {
    return this._employee.maternityPaternityLeavePeriods;
  }

  getDischargeReasons() {
    return this._employee.dischargeReasons;
  }

}

export default VacationUserDataService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/services/vacationsUserData.service.js